@if (renderItems().length > 1) {
  @if (title) {
    <h3>{{ title }}</h3>
  }
  <div class="slider" >
    @if (showNavPrevious()) {
      <svg (click)="navPrev()" (keydown.enter)="navPrev()" (keydown.space)="navPrev()" role="button" tabindex="0" aria-label="Vorherige Produkte" class="nav-prev" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="28" cy="28" r="28" fill="#F9F2EC"/>
        <path d="M 34,15.5 20.875,28.1346 34,40.7692" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    }
    <div class="items" #scroller>
      @for (product of renderItems(); track product) {
        <div class="item">
          <gea-shop-product-item
            [product]="product"
            [productAttributes]="contents().attributes"
            [presetVariant]="undefined"
            [scope]="'list'"
            [headingLevel]="4"
          ></gea-shop-product-item>
        </div>
      }
    </div>
    @if (showNavNext()) {
      <svg (click)="navNext()" (keydown.enter)="navNext()" (keydown.space)="navNext()" role="button" tabindex="0" aria-label="Weitere Produkte" class="nav-next" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="28" cy="28" r="28" fill="#F9F2EC" />
        <path d="M22 15.5L35.125 28.1346L22 40.7692" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    }
  </div>
}
